import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Subnav/sgds-subnav-item";
import { register } from "../../utils/ce-registry";

register("sgds-subnav-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-subnav-item",
  elementClass: Component,
  events: {}
});
